import { render } from "./maptest.vue?vue&type=template&id=cf2ac6ee"
import script from "./maptest.vue?vue&type=script&lang=js"
export * from "./maptest.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__